import { createIcon } from '@chakra-ui/react';

export const AcidentesPessoaisIcon = createIcon({
  displayName: 'AcidentesPessoaisIcon',
  viewBox: '0 0 75 101',
  path: [
    <path
      key="1"
      d="M39.5498 3.00001V30.5279"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="2"
      d="M8.16699 3.00001V30.5279"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="3"
      d="M42.5154 73.1812H59.5378V97.9869H18.5018C18.5018 97.9869 3.30367 98.8947 3 85.584V30.5283H42.5154V73.1812Z"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="4"
      d="M59.5371 76.8113C59.5371 76.8113 72 75.2992 72 85.5844C72 95.8695 59.5371 93.4485 59.5371 93.4485"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="5"
      d="M41.9031 55.6323L4.80371 92.1077"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="6"
      d="M38.5414 30.528L4.22754 64.2634"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
});
